import _ from 'lodash'

export const collectIngredients = (model, field, ingredients, defaultLocale ) => {
  const result = []
  _.get(model, `values[${field}].sections`, []).forEach((section, sectionIndex) => {
    if (section.ingredients) {
      section.ingredients.forEach(ingredient => {
        const originalIngredient = ingredients.find(i => i.id === ingredient.ingredientID)
        result.push({
          ...originalIngredient,
          ...(ingredient.newIngredientKey ? { newIngredientKey : ingredient.newIngredientKey } : {}),
          ...(ingredient.recipeIngredientID ? { recipeIngredientID : ingredient.recipeIngredientID } : {}),
          section: sectionIndex,
          sectionTitle: section.title[defaultLocale],
          recipeIngredient: ingredient,
        })
      })
    }
  })
  return result
}

export const findIngredient = (model, step, field) => {
  let result = {}
  _.get(model, `values[${field}].sections`, []).forEach((section, sectionIndex) => {
    if (section.ingredients) {
      section.ingredients.forEach(ingredient => {
        if(
          (ingredient.recipeIngredientID && ingredient.recipeIngredientID === step.recipeIngredientID) ||
          (ingredient.newIngredientKey && ingredient.newIngredientKey === step.newIngredientKey)) {
          result = {
            section,
            ingredient,
          }
        } else if(ingredient.replacements && ingredient.replacements.length) {
          ingredient.replacements.forEach(replacement => {
            if(
              (replacement.recipeIngredientID && replacement.recipeIngredientID === step.recipeIngredientID) ||
              (replacement.newIngredientKey && replacement.newIngredientKey === step.newIngredientKey)) {
              result = {
                section,
                ingredient: replacement,
              }
            }
          })
        }
      })
    }
  })
  return result
}

export const findIngredientImage = (ingredientId, ingredients, replacement) => {
  return ingredientId ? (ingredients.find(i => i.id === ingredientId) || {}).image : null
}

export const clearReferences = (model, step, appliance, field) => {
  const preparationSteps = _.get(model, `values[${field}].applianceSteps.${appliance.id}.preparationSteps`, [])
  const cookingSteps = _.get(model, `values[${field}].applianceSteps.${appliance.id}.cookingSteps`, [])
  const allSteps = [...preparationSteps, ...cookingSteps]
  allSteps.forEach(stepToCheck => {
    if (step.stepNewKey && stepToCheck.stepJump1NewKey === step.stepNewKey) {
      stepToCheck.stepJump1NewKey = undefined
    }
    if (step.stepNewKey && stepToCheck.stepJump2NewKey === step.stepNewKey) {
      stepToCheck.stepJump2NewKey = undefined
    }
    if (step.stepID && stepToCheck.stepJump1ID === step.stepID) {
      stepToCheck.stepJump1ID = undefined
    }
    if (step.stepID && stepToCheck.stepJump2ID === step.stepID) {
      stepToCheck.stepJump2ID = undefined
    }
  })
  return model
}
